import type { ParsedVoiceMealDraft } from "./remote-meal-parser";
import { isNutritionRowComplete } from "./nutrition-completeness";

export interface UnknownFoodTarget { itemIndex: number; componentIndex: number; name: string; dishName: string }

export function unknownFoodTargets(draft: ParsedVoiceMealDraft): UnknownFoodTarget[] {
  return (draft.nutrition?.rows ?? []).flatMap((row, itemIndex) => isNutritionRowComplete(row) ? [] : row.components.flatMap((component, componentIndex) =>
    component.ignored || (typeof component.calories === "number" && Number.isFinite(component.calories)) ? [] : [{ itemIndex, componentIndex, name: component.name, dishName: row.name }]));
}

export function ignoreUnknownFood(draft: ParsedVoiceMealDraft, target: UnknownFoodTarget): ParsedVoiceMealDraft {
  const current = draft.nutrition?.rows[target.itemIndex]?.components[target.componentIndex];
  if (!current || current.name !== target.name || current.calories !== null) return draft;
  const rows = draft.nutrition!.rows.map((row, index) => {
    if (index !== target.itemIndex) return row;
    const components = row.components.map((part, partIndex) => partIndex === target.componentIndex ? { ...part, ignored: true } : part);
    const known = components.filter(part => part.calories !== null);
    const sum = (key: "calories" | "protein" | "fat" | "carbs") => Math.round(known.reduce((total, part) => total + (part[key] ?? 0), 0) * 10) / 10;
    return { ...row, components, macrosUnknown: true, calories: known.length ? sum("calories") : null, protein: sum("protein"), fat: sum("fat"), carbs: sum("carbs") };
  });
  const total = (key: "calories" | "protein" | "fat" | "carbs") => Math.round(rows.reduce((sum, row) => sum + (row[key] ?? 0), 0) * 10) / 10;
  return { ...draft, nutrition: { rows, totalCalories: total("calories"), totalProtein: total("protein"), totalFat: total("fat"), totalCarbs: total("carbs") } };
}
